import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const CREATE_QUERY = print(gql`
  mutation CreateTeachingArea($data: CreateTeachingAreaInput!) {
    createTeachingArea(data: $data) {
      id
    }
  }
`);

export interface CreateGql {
  createTeachingArea: {
    id: number;
  };
}
